// redux/constants/action-types.ts

export const ActionTypesUser = {
    USER_SIGN_IN_REQUEST: 'USER_SIGN_IN_REQUEST',
    USER_SIGN_IN_SUCCESS: 'USER_SIGN_IN_SUCCESS',
    USER_SIGN_IN_ERROR: 'USER_SIGN_IN_ERROR',
    USER_SIGN_OUT_REQUEST: 'USER_SIGN_OUT_REQUEST',
    USER_SIGN_OUT_SUCCESS: 'USER_SIGN_OUT_SUCCESS',
    USER_SIGN_OUT_ERROR: 'USER_SIGN_OUT_ERROR',
};
